import './card.css';
import React from 'react';
import apiClient from '../../acciones/apiClient';

export const Card = ({ id, cover, title, author }) => {

    // Función para incrementar las vistas y redirigir
    const handleIncrementView = async () => {
        try {
            // Realizar la solicitud PUT para incrementar las vistas
            await apiClient.put(`/proyectos/${id}/increment-view`);
            console.log(`Vistas incrementadas para el proyecto con ID ${id}`);
            // Redirigir a la ruta '/InfoProyectos'
            window.location.href = `/InfoProyectos/${id}`;
        } catch (error) {
            console.error('Error al incrementar vistas:', error);
        }
    };

    return (
        <div className='tarjeta'>
            <div className='tarjeta-imagen'>
                <img src={cover} alt={title} className="cover-image" />
            </div>
            <div className='tarjeta-contenido'>
                <h1 className='tarjeta-titulo'>{title}</h1>
                <h3 className='tarjeta-autor'>Autor: {author}</h3>
                <button
                    className='tarjeta-boton'
                    onClick={handleIncrementView} // Cambiado a la función handleIncrementView
                >
                    Ver más!
                </button>
            </div>
        </div>
    );
};
